import { Link } from '@dropbox/dig-components/typography';
import React from 'react';
import HyperlinkInterstitialModal from 'signer-app/signature-request/hyperlink-interstitial-modal';
import { Field } from 'signer-app/types/editor-types';

export function Hyperlink(props: {
  field: Extract<Field, { type: 'hyperlink' }>;
}) {
  const { field } = props;
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <Link
        href={field.url}
        onClick={(evt) => {
          setIsOpen(true);
          evt.preventDefault();
        }}
      >
        {field.value}
      </Link>
      <HyperlinkInterstitialModal
        link={field.url}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
      />
    </>
  );
}
